jQuery(document).ready(function ($) {
    var $has_submenu = $('.menu-item-has-children > a');

    if (!$has_submenu.length) return

    $has_submenu.each(function () {
        $(this).on('click', function (e) {
            e.preventDefault();
        });
    });
});